// @ts-expect-error https://vite.dev/config/build-options.html#build-modulepreload
import "vite/modulepreload-polyfill";
window.global ||= window;
// TODO: Remove polyfills
import "./polyfill/polyfills.js";
import "./vendor/vendor.js";
import "../scss/singlepage.scss";

import { singlePageModules } from "./pages/singlePage/config.js";
import { createXylemApp } from "./createXylemApp.js";
import { initializeFontAwesome } from "./core/fontawesome.js";

initializeFontAwesome();
await createXylemApp({ modules: singlePageModules });
